import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSupportCategories,
  fetchMyTickets,
  createSupportTicket,
  fetchSupportContact
} from "./supportThunks";

const supportSlice = createSlice({
  name: "support",
  initialState: {
    categories: [],
    myTickets: [],
    supportContact: null,   
    loadingCategories: false,
    loadingTickets: false,
    loadingSupportContact: false,
    creating: false,

    errorCategories: null,
    errorTickets: null,
    createError: null,
    errorSupportContact: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // CATEGORIES
      .addCase(fetchSupportCategories.pending, (s) => {
        s.loadingCategories = true;
      })
      .addCase(fetchSupportCategories.fulfilled, (s, a) => {
        s.loadingCategories = false;
        s.categories = a.payload;
      })
      .addCase(fetchSupportCategories.rejected, (s, a) => {
        s.loadingCategories = false;
        s.errorCategories = a.payload;
      })

      // MY TICKETS
      .addCase(fetchMyTickets.pending, (s) => {
        s.loadingTickets = true;
      })
      .addCase(fetchMyTickets.fulfilled, (s, a) => {
        s.loadingTickets = false;
        s.myTickets = a.payload;
      })
      .addCase(fetchMyTickets.rejected, (s, a) => {
        s.loadingTickets = false;
        s.errorTickets = a.payload;
      })

      // CREATE TICKET
      .addCase(createSupportTicket.pending, (s) => {
        s.creating = true;
      })
      .addCase(createSupportTicket.fulfilled, (s, a) => {
        s.creating = false;
        s.myTickets.unshift(a.payload);
      })
      .addCase(createSupportTicket.rejected, (s, a) => {
        s.creating = false;
        s.createError = a.payload;
      });

      // SUPPORT CONTACT
       builder
.addCase(fetchSupportContact.pending, (s) => {
  s.loadingSupportContact = true;
})
.addCase(fetchSupportContact.fulfilled, (s, a) => {
  s.loadingSupportContact = false;
  s.supportContact = a.payload;
})
.addCase(fetchSupportContact.rejected, (s, a) => {
  s.loadingSupportContact = false;
  s.errorSupportContact = a.payload;
})

  },
});

export default supportSlice.reducer;
